<template>
  <div>
    <div class="flex items-center mb-2 ml-4 gap-y-3" :class="{ 'justify-between': showBtn, 'justify-end': !showBtn }">
      <!-- LEFT SIDE (date select + save/ocr group) -->
      <div class="flex items-center gap-3 min-w-0">
        <el-form>
          <el-form-item v-if="pageStatus == 1 && (this.userInfo.role == 4 || this.userInfo.role == 5)"
            label="Vetting Request Date" prop="vettingRequestDate" class="mb-0" size="mini">
            <el-select v-model="vettingRequestDate" style="width: 220px">
              <el-option v-for="date in vettingRequestDates" :key="date" :label="date" :value="date" />
            </el-select>
          </el-form-item>
        </el-form>

        <div class="flex items-center gap-2 shrink-0">
          <el-button size="mini" type="primary" v-if="canSaveInfo" @click="handleSaveClickTerminal">
            Save Ship Informations
          </el-button>
          <el-button size="mini" type="primary" v-if="ocrBtn" :loading="ocrUploading" @click="openOcrDialog">
            Upload OCR
          </el-button>
        </div>
      </div>

      <!-- RIGHT SIDE (action buttons) -->
      <div class="flex items-center justify-end gap-y-2 flex-1 flex-wrap">
        <template v-if="showBtn">
          <el-button size="mini" @click="handleCloseClick">Close</el-button>

          <el-button size="mini" type="primary" v-if="submitToTerminalBtn" @click="handleStatusButtonClick(0)">
            Submit To Terminal Approval
          </el-button>
          <el-button size="mini" type="primary" v-if="resubmitChangesBtn" @click="handleStatusButtonClick(1)">
            Resubmit Changes
          </el-button>
          <el-button size="mini" type="primary" v-if="submitBtn" @click="confirmToSubmitDialog = true">
            Submit
          </el-button>

          <el-button size="mini" type="success" v-if="acceptBtn" @click="handleStatusButtonClick(6)">Accept</el-button>
          <el-button size="mini" type="danger" v-if="rejectBtn"
            @click="terminalReqRemarkDialog = true">Reject</el-button>

          <el-button size="mini" type="primary" v-if="submitToInspectionBtn" @click="handleStatusButtonClick(2)">
            Submit for Inspection
          </el-button>
          <el-button size="mini" type="primary" v-if="pendingObsBtn" @click="handleStatusButtonClick(12)">
            Pending Observation
          </el-button>
          <el-button size="mini" type="primary" v-if="anchorageInspectionBtn" @click="handleStatusButtonClick(4)">
            Anchorage Inspection
          </el-button>
          <el-button size="mini" type="primary" v-if="moreInfoRequiredBtn" @click="logisticsRemarksDialog = true">
            More Information Required
          </el-button>
          <el-button size="mini" type="primary" v-if="suspendedBtn" @click="suspendedDialog = true">Suspend</el-button>
          <el-button size="mini" type="danger" v-if="deleteBtn" @click="confirmToDeleteDialog = true">Delete</el-button>

          <span class="mx-3 whitespace-nowrap"
            :style="{ fontSize: '12px', color: getStatusColor(this.requestData.shipStatus || this.requestData.status) }">
            {{ getShipVetStatus() }}
          </span>
        </template>

        <template v-else>
          <el-button size="mini" type="primary" v-if="saveBtn" @click="handleSaveClick">Save</el-button>
          <el-button size="mini" type="primary" v-if="pendingObsBtn" @click="handleStatusButtonClick(13)">
            Pending Observation
          </el-button>
          <el-button size="mini" type="primary" v-if="submitToInspectionBtn" @click="handleStatusButtonClick(11)">
            Submit for Inspection
          </el-button>
          <el-button size="mini" @click="handleCloseClick">Close</el-button>
          <el-button size="mini" type="primary" v-if="ocrBtn" :loading="ocrUploading" @click="openOcrDialog">
            Upload OCR
          </el-button>

          <span class="mx-3 whitespace-nowrap"
            :style="{ fontSize: '12px', color: getStatusColor(this.requestData.shipStatus || this.requestData.status) }">
            {{ getShipVetStatus() }}
          </span>
        </template>
      </div>
    </div>
    <div class="flex flex-row ">
      <div class="ship-detail"
        :style="{ padding: '20px 20px', backgroundColor: '#ffffff', borderRadius: '10px', marginLeft: '20px', height: 'calc(108vh - 210px)', width: this.pageStatus == 2 ? 'calc(200vh - 190px)' : '50%' }">
        <div class="my-3 flex flex-wrap justify-between gap-2">
          <span v-if="pageStatus == 1">{{ requestData.shipName }}</span>
          <span v-if="pageStatus == 2 && (this.userInfo.role == 4 || this.userInfo.role == 5)">Create a New
            Request</span>
          <span v-if="pageStatus == 2 && !(this.userInfo.role == 4 || this.userInfo.role == 5)">Create a New Ship</span>

        </div>
        <ShipVettingInformation ref="shipVettingForm" :requestData="requestData"
          @get-list="getShipVettingReqeustDetail" />


        <el-dialog title="Confirm To Submit" :visible.sync="confirmToSubmitDialog"
          :width="isMobileScreen ? '100%' : '500px'">
          <div>
            Once submitted, the request cannot be modified.
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="confirmToSubmitDialog = false">Cancel</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(1)">Submit</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog :title="`${previousRecordData[0]?.companyName || ''} History Record`"
          :visible.sync="previousRecordDialog" :width="isMobileScreen ? '100%' : '930px'">
          <div>
            <el-table key="previousRecords" :data="previousRecordData" :header-cell-style="{
              height: '55px',
              background: '#fff',
              'border-bottom': '2px solid #D6D9E1',
            }" :cell-style="getCellStyle" table-layout="auto"
              style="width: 10%; height: calc(40vh - 90px); overflow-y: scroll;">
              <el-table-column align="left" prop="companyName" label="Company" min-width="100"></el-table-column>
              <el-table-column align="left" prop="status" label="Status" min-width="150">
                <template slot-scope="scope">
                  <div>
                    {{ getShipVettingStatus(scope.row.status) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="File Name" min-width="300">
                <template slot-scope="scope">
                  <div v-if="scope.row.documents && scope.row.documents.length > 0">
                    <div v-for="(file, index) in scope.row.documents" :key="index"
                      @click="viewFile(scope.row.documents[index])">
                      <h1 style="color: #409EFF;">{{ index + 1 }}. {{ file.originalFileName }}</h1>
                    </div>
                  </div>
                  <div v-else>
                    No Files
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="createBy" label="Create By" min-width="130"></el-table-column>
              <el-table-column align="left" prop="createTime" label="Create Time" min-width="200"></el-table-column>
            </el-table>
          </div>
        </el-dialog>

        <pdf-view title="Ship Document" :pdfUrl="pdfUrl" v-model="showPdfView" />

        <el-dialog title="Confirm To Delete" :visible.sync="confirmToDeleteDialog"
          :width="isMobileScreen ? '100%' : '500px'">
          <div>
            Are you sure you want to delete this request?
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="confirmToDeleteDialog = false">Cancel</el-button>
              <el-button type="danger" size="mini" @click="handleDelete()">Delete</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="More Information Required" :visible.sync="logisticsRemarksDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetLogisticsRemarksForm()">
          <div>
            <el-form ref="remarksForm" :rules="rules" :model="logisticsRemarksForm">
              <el-form-item label="Please state the remark:" prop="logisticsRemarks">
                <el-input type="textarea" v-model="logisticsRemarksForm.logisticsRemarks" :autosize="{ minRows: 3 }"
                  clearable size="small" style="width:100%" />
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetLogisticsRemarksForm()">{{ $t("btn.close")
                }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(8)">{{ $t("btn.submit")
                }}</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Reject Company Request" :visible.sync="companyReqRemarkDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetCompanyReqRemark()">
          <div>
            <el-form label-width="auto" size="mini" label-position="top" ref="companyReqRemarkForm" :rules="rules"
              :model="companyReqRemarks">
              <el-form-item label="Please state the remark:" prop="companyReqRemarks">
                <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="companyReqRemarks" clearable size="small"
                  :style="{ width: '100%' }"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetCompanyReqRemark()">{{ $t("btn.close")
                }}</el-button>
              <el-button type="primary" size="mini" @click="handleCompanyReq(rejectedId, 5)">{{ $t("btn.submit")
                }}</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Reject Terminal Request" :visible.sync="terminalReqRemarkDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetTerminalReqRemark()">
          <div>
            <el-form label-width="auto" size="mini" label-position="top" ref="terminalReqRemarkForm" :rules="rules"
              :model="terminalReqRemark">
              <el-form-item label="Please state the remark:" prop="terminalReqRemark">
                <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="terminalReqRemark" clearable size="small"
                  :style="{ width: '100%' }"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetTerminalReqRemark()">{{ $t("btn.close")
              }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(5)">{{ $t("btn.submit")
              }}</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Suspend Ship" :visible.sync="suspendedDialog" :width="isMobileScreen ? '100%' : '500px'"
          @close="resetSuspendedForm()">
          <div>
            <el-form label-width="auto" size="mini" label-position="left" ref="suspendedForm">
              <el-form-item label="Start Date" prop="suspendedStartDate">
                <el-date-picker v-model="suspendedStartDate" placeholder="Start Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>
              <el-form-item label="End Date" prop="suspendedEndDate">
                <el-date-picker v-model="suspendedEndDate" placeholder="End Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetSuspendedForm()">{{ $t("btn.close")
                }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(10)">{{ $t("btn.submit")
              }}</el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog title="Upload OCR Document (Q88)" :visible.sync="ocrDialogVisible"
          :width="isMobileScreen ? '100%' : '400px'" @close="resetOcrDialog" style="justify-items: center;">
          <el-upload ref="ocrUploader" class="ocr-upload" drag :auto-upload="false" :file-list="ocrFileList" :limit="1"
            :on-change="handleOcrFileChange" :on-remove="handleOcrFileRemove" :on-exceed="handleOcrExceed"
            :on-preview="handleOcrPreview" accept=".pdf,.doc,.docx" style="width: 100%; justify-items: center;">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" style="width: 100%; justify-items: center;">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              Supported: PDF/DOC/DOCX
            </div>
          </el-upload>

          <template #footer>
            <div class="dialog-footer">
              <el-button plain size="mini" @click="ocrDialogVisible = false">Cancel</el-button>
              <el-button type="primary" size="mini" :loading="ocrUploading" @click="submitOcr">
                OCR & Fill Form
              </el-button>
            </div>
          </template>
        </el-dialog>
      </div>
      <div>
      </div>
      <div class="flex flex-col w-1/2" v-if="showRightBar">
        <div v-if="showCompanyReq"
          style="padding:20px 20px; background-color:#ffffff; border-radius: 10px; margin-left: 20px; margin-bottom: 20px; height: 50%;">
          <h3 class="text-lg font-medium">Company Request</h3>
          <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
          <el-table key="shipVettingList" :data="listData" :header-cell-style="{
            height: '55px',
            background: '#fff',
            'border-bottom': '2px solid #D6D9E1',
          }" :cell-style="getCellStyle" @row-click="handleTableRowClick" table-layout="auto"
            style="width: 10%; height: calc(40vh - 90px); overflow-y: scroll;">
            <el-table-column align="left" prop="companyName" label="Company" min-width="100"></el-table-column>
            <el-table-column align="left" prop="status" label="Status" min-width="100">
              <template slot-scope="scope">
                <div>
                  {{ getShipVettingStatus(scope.row.status) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="customerRemarks" label="Customer Remarks"
              min-width="160"></el-table-column>
            <el-table-column align="left" label="File Name" min-width="320">
              <template slot-scope="scope">
                <div v-if="scope.row.documents && scope.row.documents.length > 0">
                  <div v-for="(file, index) in scope.row.documents" :key="index"
                    class="flex items-center flex-row gap-x-2">
                    <h1 style="color: #409EFF;" @click="viewFile(scope.row.documents[index])">{{ index + 1 }}. {{
                      file.originalFileName }}</h1>
                    <el-button circle size="mini" type="primary" icon="el-icon-document-copy"
                      @click="$refs.shipVettingForm.handleFileDuplicated(file)"
                      v-if="!shipDocumentDisabled"></el-button>
                  </div>

                </div>
                <div v-else>
                  No Files
                </div>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="action" label="Action" min-width="300" v-if="userInfo.role == 1">
              <template slot-scope="scope">
                <el-button size="mini" type="success" plain v-if="showCompanyReqAccept(scope.row.status)"
                  @click.stop="handleCompanyReq(scope.row.id, 6)">Accept</el-button>
                <el-button size="mini" type="danger" plain v-if="showCompanyReqReject(scope.row.status)"
                  @click.stop="handleRejectCompanyReq(scope.row.id)">Reject</el-button>
                <el-button size="mini" style="color: #409EFF; border-color: #409EFF;"
                  @click="handlePassRecordClick(scope.row.id)">Past
                  Record</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="pageStatus == 1"
          :style="{ padding: '20px 20px', backgroundColor: '#ffffff', borderRadius: '10px', marginLeft: '20px', height: contentHeight() }">
          <h3 class="text-lg font-medium ">Timeline</h3>
          <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
          <ShipVettingTimeline :key="rid" :rid="rid" :requestData="this.requestData"></ShipVettingTimeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from "@/components/tabs.vue";
import { getShipVettingRequestData, deleteShipVettingRequest, modifyLogisticsRequest, getCustomerVettingInfo, getCreateDateList, getCompanyListByImo, getCustomerVettingRecord, updateCustomerVettingStatus, deleteCustomerVetting, uploadFileAPI, ocrShipVettingData, } from "@/services";
import PdfView from "@/components/common/pdf-view.vue";
import { mapState } from "vuex";
import ShipVettingHistory from "./history.vue";
import ShipVettingInformation from "./information.vue"
import { getShipVettingStatus } from "@/utils/constants";
import ShipVettingTimeline from './timeline.vue';
import { getServerUrl } from "@/utils/getServerUrl";

export default {
  name: "ShipVettingDetail",
  components: { tabs, PdfView, ShipVettingInformation, ShipVettingHistory, ShipVettingTimeline },

  data() {
    return {
      activeTab: "informationTab",
      // activeTab: "historyTab",
      historyKey: 0,
      id: "",
      pageStatus: "", // page mode
      requestStatus: 0,
      // upIndex: 0,
      imo: "",
      shipName: "",
      requestData: {},
      confirmToSubmitDialog: false,
      confirmToDeleteDialog: false,
      // subbtns: false,
      showBtn: true,
      showStatus: "",
      submitToTerminalBtn: false,
      resubmitChangesBtn: false,
      acceptBtn: false,
      rejectBtn: false,
      submitToInspectionBtn: false,
      anchorageInspectionBtn: false,
      moreInfoRequiredBtn: false,
      suspendedBtn: false,
      submitBtn: false,
      deleteBtn: false,
      suspendedDialog: false,
      suspendedStartDate: null,
      suspendedEndDate: null,
      saveBtn: false,
      showCompanyReq: false,
      listData: [],
      vettingRequestDates: [
      ],
      vettingRequestDate: "",
      rid: "",
      previousRecordDialog: false,
      previousRecordData: [],
      showPdfView: false,
      pdfUrl: "",
      vettingReqList: [],
      showRightBar: false,
      companyReqRemarkDialog: false,
      companyReqRemarks: "",
      terminalReqRemarkDialog: false,
      terminalReqRemark: "",
      rejectedId: 0,
      pendingObsBtn: false,
      baseUrl: getServerUrl(),
      logisticsRemarksDialog: false,
      logisticsRemarksForm: {
        logisticsRemarks: ""
      },
      ocrBtn: false,
      ocrDialogVisible: false,
      ocrUploading: false,
      ocrFileList: [],
      rules: {
        logisticsRemarks: [{ required: true, message: " ", trigger: "blur" }],
        companyReqRemarks: [
          { required: true, message: " ", trigger: "blur" },
        ],
        terminalReqRemark: [
          { required: true, message: " ", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },

    shipDocumentDisabled() {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;

      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (pageStatus == 2) {
        return false;
      }
      if (Number(this.requestData.id) !== Number(this.$route.query.id)) {
        return true;
      }
      if (isLogistics && (requestStatus == 1 || requestStatus == 3 || requestStatus == 9 || requestStatus == 4)) {
        return false;
      }
      if ((isCustomer || isLogistics) && (requestStatus == 1 || requestStatus == 7 || requestStatus == 8)) {
        return false;
      }
      return true;
    },

    canSaveInfo() {
      const pageStatus = Number(this.$route.query.pageStatus ?? 0);
      if (pageStatus !== 1) return false;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (requestStatus == 10 || requestStatus == 9) return false;

      const role = this.userInfo?.role;
      const isLogistics = role == 1 || role == "1";
      return isLogistics;
    },
  },
  created() {
    this.getShipVettingReqeustDetail();
  },
  watch: {
    vettingRequestDate(newVal) {
      const selectedItem = this.vettingReqList.find((item) => item.createTime === newVal);

      if (selectedItem) {
        this.selectedItemId = selectedItem.id;
        getCustomerVettingInfo(selectedItem.id).then((res) => {
          if (res.code === 200) {
            this.requestData = res.data;
            this.imo = res.data.imo;
            this.historyKey += 1;
            this.rid = res.data.id;
            this.showButtons();
          }
        });
      }
    },
  },
  mounted() {
    const { id, pageStatus } = this.$route.query;
    this.id = id;
    this.pageStatus = pageStatus;
    // this.getShipVettingReqeustDetail();
  },
  methods: {
    getShipVettingStatus,
    showCompanyReqAccept(status) {
      if (this.requestData.shipStatus == 6) {
        if (status == 6) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    showCompanyReqReject(status) {
      if (status == 5) {
        return false;
      } else {
        return true;
      }
    },
    getShipVettingReqeustDetail() {
      this.logisticsRemarks = "";
      if (this.$route.query.pageStatus == 2) {
        this.showButtons();
        return;
      }
      if (!(this.userInfo.role == 4 || this.userInfo.role == 5)) {
        getShipVettingRequestData(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.requestData = res.data
            this.imo = res.data.imo
            this.historyKey += 1;
            this.rid = res.data.id;
            this.showButtons();
          }
          getCompanyListByImo(this.imo).then((res) => {
            if (res.code == 200) {
              this.listData = res.data;
              this.listData.file
            }
          });
        });
      } else {
        getCreateDateList({ imo: this.$route.query.imo }).then((res) => {
          if (res.code == 200) {
            const data = res.data;
            this.vettingRequestDates = [];
            this.vettingReqList = data;

            data.forEach((item) => {
              this.vettingRequestDates.push(item.createTime);
            });
            const selectedItem = data.find((item) => item.id === this.$route.query.id || item.id === Number(this.$route.query.id)) || data[0];
            this.vettingRequestDate = selectedItem.createTime;

            getCustomerVettingInfo(selectedItem.id).then((res) => {
              if (res.code == 200) {
                this.requestData = res.data;
                this.imo = res.data.imo;
                this.historyKey += 1;
                this.rid = res.data.id;
                this.showButtons();
              }
            });
          }
        });
      }
    },

    contentHeight() {
      if (this.showRightBar) {
        if (this.showCompanyReq) {
          return "calc(66vh - 200px)"
        }
        return "calc(108vh - 210px)";
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 5:
        case 9:
        case 10:
          return "red";
        case 6:
          return "green";
        default:
          return "#57a2de";
      }
    },

    getCellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return {
          backgroundColor: "rgba(255,255,255,0.2)",
        };
      } else {
        return {
          backgroundColor: "rgba(228,228,228,0.2)",
        };
      }
    },
    viewFile(file) {
      if (file.documentUrl) {
        this.pdfUrl = process.env.VUE_APP_BASE_API + file.documentUrl,
          this.showPdfView = true;
      } else {
        this.$message.warning('Unable to view the file');
      }
    },
    showButtons(val) {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const isInspector = this.userInfo.role == 13;
      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      const routePageStatus = Number(this.$route.query.pageStatus ?? 0);
      const isLogisticView = this.userInfo.role == 16

      // show OCR on Create page (pageStatus=2) for customer + logistics (adjust if you want only customer)
      this.ocrBtn = routePageStatus === 2 && (isCustomer || isLogistics);

      // create new request
      if (pageStatus == 2) {
        if (isLogistics) {
          this.acceptBtn = true;
          this.rejectBtn = true;
          this.submitToInspectionBtn = true;
          this.anchorageInspectionBtn = true;
          this.moreInfoRequiredBtn = true;
          this.suspendedBtn = true;
        }
        if (isCustomer) {
          this.submitToTerminalBtn = true;
        }
        return;
      }

      if(isLogisticView){
        this.showRightBar = true;
        this.showCompanyReq = true;
      }

      // modify request
      if (isLogistics) {
        this.showRightBar = true;
        this.showCompanyReq = true;
        if (requestStatus == 1 || requestStatus == 3 || requestStatus == 6 || requestStatus == 5 || requestStatus == 9) {
          this.showBtn = true;
          this.pendingObsBtn = requestStatus == 6;
          this.acceptBtn = true;
          this.rejectBtn = true;
          this.anchorageInspectionBtn = true;
          this.moreInfoRequiredBtn = true;
          this.suspendedBtn = true;
          if (requestStatus == 1 || requestStatus == 9) {
            this.submitToInspectionBtn = true;
          }
          if (requestStatus == 6) {
            this.acceptBtn = false;
            this.submitToInspectionBtn = true;
          }
          if (requestStatus == 5) {
            this.rejectBtn = false;
            this.submitToInspectionBtn = true;
          }
        } else {
          if (requestStatus == 4) {
            this.saveBtn = false;
            this.pendingObsBtn = true;
            this.submitToInspectionBtn = true;
          } else {
            this.saveBtn = true;
            this.pendingObsBtn = false;
            this.submitToInspectionBtn = false;
          }
          this.handleShowStatus();
        }
      }
      if (isCustomer) {
        this.showRightBar = true;
        if (Number(this.selectedItemId) !== Number(this.$route.query.id)) {
          this.showBtn = false;
          this.disableForm = true;
        } else if (requestStatus == 1) {
          this.showBtn = true;
          this.resubmitChangesBtn = true;
          this.submitBtn = false;
          this.deleteBtn = true;
        } else if (requestStatus == 7 || requestStatus == 8) {
          this.showBtn = true;
          this.resubmitChangesBtn = false;
          this.submitBtn = true;
          this.deleteBtn = false;
        } else {
          this.handleShowStatus();
        }
      }
      if (isInspector) {
        this.saveBtn = false;
        this.showRightBar = true;
        if ((requestStatus == 2 || requestStatus == 4)) {
          this.submitBtn = true;
        } else {
          this.pendingObsBtn = requestStatus == 6;
          this.handleShowStatus();
        }
      }
      this.ocrBtn = (this.pageStatus == 2) && (
        this.userInfo.role == 1 || this.userInfo.role == 4 || this.userInfo.role == 5
      );
    },
    handleShowStatus() {
      this.showBtn = false;
      this.showStatus = getShipVettingStatus(this.requestData.shipStatus);

      if (this.requestData.status === 10) {
        const sus = this.showStatus;
        const susStart = this.requestData.suspendedStart;
        const susEnd = this.requestData.suspendedEnd;
        if (!susStart && !susEnd) {
          return;
        }
        this.showStatus = sus + " from " + susStart + " to " + susEnd;
      }
    },
    async fetchDoc(doc) {
      const docUrl = doc.documentUrl.startsWith('https')
        ? doc.documentUrl
        : this.baseUrl + doc.documentUrl;
      const response = await fetch(docUrl, { method: "GET" });
      const blob = await response.blob();

      return new File([blob], doc.originalFileName, { type: blob.type });
    },
    handleCloseClick() {
      this.pageStatus = 0;
      if (this.$route.query.pageStatus == 2) {
        this.requestData = {};
      }
      // this.$router.back();
      this.$router.push({ path: "/ship-vetting/index" });
      // fix back error
      setTimeout(() => {
        if (this.$route.path == "/ship-vetting/index" && this.$route.query.id) {
          this.$router.push({ path: "/ship-vetting/index" });
        }
      }, 500);
    },
    handleStatusButtonClick(status) {
      // Suspended
      if (status == 10) {
        if ((this.suspendedStartDate == null || this.suspendedEndDate == null)) {
          this.$message.error("Start Date and End Date required");
          return;
        }
        if (new Date(this.suspendedEndDate) < new Date(this.suspendedStartDate)) {
          this.$message.error("End Date must be after Start Date");
          return;
        }
      }

      if (status === 8 && (!this.logisticsRemarksForm.logisticsRemarks || !this.logisticsRemarksForm.logisticsRemarks.trim())) {
        this.$refs.remarksForm?.validate();
        this.$message.error("Remark required");
        return;
      }

      const params = {
        status: status,
        logisticsRemarks: this.logisticsRemarksForm.logisticsRemarks,
        suspendedStartDate: this.suspendedStartDate,
        suspendedEndDate: this.suspendedEndDate,
      }


      if (status == 5 && this.terminalReqRemarkDialog == true) {
        this.$refs["terminalReqRemarkForm"].validate();
        if (this.terminalReqRemark == null || this.terminalReqRemark.trim() == "") {
          this.$message.error("Remark cannot be empty");
          return;
        }
        delete params.logisticsRemarks;
        delete params.suspendedStartDate;
        delete params.suspendedEndDate;
        params.rejectRemarks = this.terminalReqRemark;
      }


      this.$refs.shipVettingForm.updateRequest(params, () => {
        this.confirmToSubmitDialog = false;
        this.resetTerminalReqRemark();
        this.resetLogisticsRemarksForm();
        this.resetSuspendedForm();
      });


    },
    handleDelete() {
      if (this.requestData.status != 1) {
        this.$message.error("Request status has been changed. Not allowed to delete.");
        return;
      }
      if (this.userInfo.role == 4 || this.userInfo.role == 5) {
        deleteCustomerVetting(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.$message.success("Request deleted");
            this.handleCloseClick();
          } else {
            this.$message.error("Failed to delete request");
          }
        });
      } else {
        deleteShipVettingRequest(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.$message.success("Request deleted");
            this.handleCloseClick();
          }
        });
      }
    },
    getShipVetStatus() {
      const stat = getShipVettingStatus(this.requestData.shipStatus || this.requestData.status);
      if (this.requestData.shipStatus == 10 || this.requestData.status == 10) {
        const sus = stat;
        const susStart = this.requestData.suspendedStart;
        const susEnd = this.requestData.suspendedEnd;
        if (!susStart && !susEnd) {
          return stat;
        }
        return sus + " from " + susStart + " to " + susEnd;
      }
      return stat;
    },
    handleRejectCompanyReq(id) {
      this.rejectedId = id;
      this.companyReqRemarkDialog = true;
    },
    resetLogisticsRemarksForm() {
      this.logisticsRemarksDialog = false;
      this.logisticsRemarksForm.logisticsRemarks = "";
      this.$nextTick(() => this.$refs.remarksForm?.clearValidate());
    },

    resetSuspendedForm() {
      this.suspendedDialog = false;
      this.suspendedStartDate = null;
      this.suspendedEndDate = null;
    },
    resetCompanyReqRemark() {
      // this.$refs["companyReqRemarkForm"].clearValidate();
      this.companyReqRemarkDialog = false;
      this.companyReqRemarks = "";
    },
    resetTerminalReqRemark() {
      // this.$refs["terminalReqRemarkForm"].clearValidate();
      this.terminalReqRemarkDialog = false;
      this.terminalReqRemark = "";
    },
    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return '';
      return cellValue.replace('T', ' ');
    },
    async handleSaveClick() {
      // pass the current status back into the child so it can
      // both update the data and upload/delete files
      await this.$refs.shipVettingForm.updateRequest({
        status: this.requestData.status,
        skipStatusUpdate: true
      });
    },
    async handleSaveClickTerminal() {
      // Save "terminal info" only (no status change, no file upload) - API: /shipVetting/updateRequestInfo/{id}
      if (this.$refs.shipVettingForm?.saveRequestInfoOnly) {
        await this.$refs.shipVettingForm.saveRequestInfoOnly();
      }
    },
    handlePassRecordClick(imo) {
      this.previousRecordDialog = true;
      getCustomerVettingRecord(imo).then((res) => {
        if (res.code == 200) {
          this.previousRecordData = res.data;
        } else {
          this.$message.error("Failed to fetch previous records");
        }
      });
    },
    handleCompanyReq(id, status) {
      if (this.companyReqRemarkDialog == true) {
        this.$refs["companyReqRemarkForm"].validate();
        if (this.companyReqRemarks == null || this.companyReqRemarks.trim() == "") {
          this.$message.error("Remark cannot be empty");
          return;
        }
      }
      const reqBody = {
        id: id,
        status: status,
        terminal_remarks: this.companyReqRemarks ?? undefined,
      };
      updateCustomerVettingStatus(reqBody).then((res) => {
        if (res.code == 200) {
          this.$message.success("Request updated successfully");
          this.getShipVettingReqeustDetail();
          this.resetCompanyReqRemark();
        } else {
          this.$message.error("Failed to update request");
        }
      });
    },
    openOcrDialog() {
      this.ocrDialogVisible = true;
    },

    handleOcrFileChange(file, fileList) {
      const raw = file?.raw;
      const name = (raw?.name || file?.name || "").toLowerCase();

      const allowed = name.endsWith(".pdf") || name.endsWith(".doc") || name.endsWith(".docx");

      if (!allowed) {
        this.$message.error("Only PDF / DOC / DOCX are allowed");
        this.$refs.ocrUploader?.clearFiles();
        this.ocrFileList = [];
        return;
      }

      this.ocrFileList = (fileList || []).slice(-1);
    },

    handleOcrExceed(files) {
      const raw = files[0];
      this.$refs.ocrUploader.clearFiles();
      this.$refs.ocrUploader.handleStart(raw);

      this.$nextTick(() => {
        this.ocrFileList = (this.$refs.ocrUploader.uploadFiles || []).slice(-1);
      });
    },

    handleOcrFileRemove() {
      this.ocrFileList = [];
    },

    resetOcrDialog() {
      this.ocrUploading = false;
      this.ocrFileList = [];
      if (this.$refs.ocrUploader) this.$refs.ocrUploader.clearFiles();
    },

    async submitOcr() {
      const list = this.$refs.ocrUploader?.uploadFiles?.length
        ? this.$refs.ocrUploader.uploadFiles
        : this.ocrFileList;

      if (!list || list.length === 0) {
        this.$message.error("Please upload a file first");
        return;
      }

      const rawFile = list[0]?.raw || list[0]; // support both shapes
      if (!rawFile) {
        this.$message.error("Invalid file");
        return;
      }

      const fd = new FormData();
      fd.append("file", rawFile);

      this.ocrUploading = true;
      try {
        const res = await ocrShipVettingData(fd);

        const payload = res?.data ?? res;

        if (this.$refs.shipVettingForm?.applyOcrData) {
          this.$refs.shipVettingForm.applyOcrData(payload);
          this.$message.success("OCR result applied to form");
        } else {
          this.$message.warning("Form reference not found (shipVettingForm)");
        }

        this.ocrDialogVisible = false;
        this.resetOcrDialog();
      } catch (e) {
        this.$message.error("OCR failed");
        console.error(e);
      } finally {
        this.ocrUploading = false;
      }
    },
    handleOcrPreview(file) {
      const raw = file?.raw;
      if (!raw) {
        this.$message.warning("No file to preview");
        return;
      }

      const name = (raw.name || "").toLowerCase();

      if (name.endsWith(".pdf")) {
        const url = URL.createObjectURL(raw);

        this.pdfUrl = url;
        this.showPdfView = true;
        return;
      }

      if (name.endsWith(".doc") || name.endsWith(".docx")) {
        this.$message.warning(
          "DOC/DOCX files cannot be previewed. Please download and open locally."
        );
        return;
      }

      this.$message.error("Unsupported file type");
    },
  },
};
</script>

<style scoped lang="scss">
.ship-detail {
  height: 100%;
  overflow-y: scroll;
}

.divider-line {
  padding-bottom: 5px;
  border-bottom: 3px solid #e5e7ed;
}

.ocr-upload .el-upload-dragger {
  display: flex;
  flex-direction: column;
}

.ocr-upload .el-upload-dragger {
  height: 180px;
}

.ocr-upload .el-icon-upload {
  margin-bottom: 8px;
}

.ocr-upload .el-upload__text {
  line-height: 1.4;
}
</style>
